// GA4 helpers for Advanced Consent Mode.
// We always forward events to gtag; Google's Consent Mode decides what is
// stored vs. sent as limited/cookieless signals based on the current consent
// state. We NEVER pass PII (names, emails, phone numbers, postcodes,
// addresses, free-text form contents) — only non-identifying context.
export const GA_MEASUREMENT_ID = "G-3XD9L4B4C6";

export function gaEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

export function gaPageView(path) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: typeof document !== "undefined" ? document.title : undefined,
    });
  }
}
